export enum FORM_STATUS {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  INACTIVE = 'INACTIVE',
}

export enum VALIDATOR_ACTIONS {
  DISPLAY_IF = 'DISPLAY_IF',
  ENABLE_IF = 'ENABLE_IF',
  REQUIRE_IF = 'REQUIRE_IF',
  IS_VALID = 'IS_VALID',
  SUBMIT_FORM = 'SUBMIT_FORM',
  REJECT_FORM = 'REJECT_FORM',
}

export enum KIOSK_FORM_STATES {
  WelcomeScreen,
  InProgress,
  CompletedSuccess,
  CompletedFail,
}

export enum VALIDATOR_OPERATORS {
  PLUS = 'PLUS',
  MINUS = 'MINUS',
  TIMES = 'TIMES',
  DIVISION = 'DIVISION',
  OR = 'OR',
  AND = 'AND',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  EQUAL_TO = 'EQUAL_TO',
  NOT_EQUAL_TO = 'NOT_EQUAL_TO',
  LESSER_THAN = 'LESS_THAN',
  LESSER_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL_TO = 'GREATER_THAN_OR_EQUAL_TO',
}

export enum BOUNDARY_OPERATIONS {
  EQUAL_TO = 'EQUAL_TO',
  NOT_EQUAL_TO = 'NOT_EQUAL_TO',
}

export enum BOUNDARY_OPERAND_TYPE {
  CONTROL = 'CONTROL',
  VALUE = 'VALUE',
}

export enum STEP_CONDITION_ACTIONS {
  DISPLAY_IF = 'DISPLAY_IF',
}

export enum FORM_BUILDER_CONSTANTS {
  VALUE = 'value',
  LABEL = 'label',
  ATTRIBUTE = 'attribute',
  DISTANCE_ATTRIBUTE = 'proximity_distance_attribute',
  DISTANCE = 'distance',
  PROXIMITY = 'proximity',
  LENGTH = 'length',
  PATH = 'path',
  SUBPATH = 'subPath',
  ITEMS = 'items',
  FEATURES = 'features',
  FORM_DEFINITION_BASE_ID = 'FormDefinitionBaseId',
}

export enum FORM_CONTROL_TYPES {
  GROUP = 'group',
  COORDINATES = 'coordinates',
  FILE = 'file',
  CHOICE = 'choice',
  CHECKBOX = 'checkbox',
  TEXT = 'text',
  NUMBER = 'number',
  RADIO = 'radio',
  DATE = 'date',
  TEXTAREA = 'textarea',
  SIGNATURE = 'signature',
  DIAGRAM = 'diagram',
  DIVIDER = 'divider',
  HEADER = 'header',
  QR_CODE_SCANNER = 'qrCodeScanner',
  CHOICE_IMAGE = 'choiceImage',
}

export enum FORM_CONTROL_MODES {
  WAYPOINT = 'waypoint',
  IMAGE = 'image',
  AUDIO = 'audio',
  VIDEO = 'video',
  TIME = 'time',
  DATE = 'date',
  DECIMAL = 'decimal',
}

export enum BADGE_CONTROLS {
  TIMESTAMP = 'badge_timestamp',
  FIRST_NAME = 'badge_first_name',
  LAST_NAME = 'badge_last_name',
  EMPLOYEE_NUMBER = 'badge_employee_number',
  EMAIL = 'badge_email',
  PHONE_NUMBER = 'badge_phone_number',
  ORGANIZATION_NAME = 'badge_organization_name',
  APPLICATION_ROLE = 'badge_application_role',
}

export enum CALCULATED_CONTROL_TYPES {
  MATH = 'math',
  DELIMITER = 'delimiter',
  SUM = 'sum',
  CHOICE = 'choice',
  AVERAGE = 'average',
}

export enum FORM_ALERT_MODES {
  VIBRATE = 'vibrate',
  AUDIO = 'audio',
  AUDIO_VIBRATE = 'audio/vibrate',
  SILENT = 'silent',
}

export enum FORM_ALERT_TIMINGS {
  START = 'start',
  FOCUS = 'focus',
  COMPLETE = 'complete',
  BLUR = 'blur',
}

export enum FORM_DEFAULT_PROMPTS {
  ACTION = 'action',
  DISMISS = 'dismiss',
}

export enum QR_CODE_TYPES {
  SHARED_FORM = 'ticket',
  /** Previously named RECEIPT. String value kept as 'receipt' for backward compatibility with stored form definitions. */
  DRIVER_APP = 'receipt',
}

export enum RECEIPT_PLACEHOLDERS {
  FLEX_FORM_QR_CODE = 'FLEX_FORM_QR_CODE',
  PRINT_TEMPLATE_QR_CODE = 'PRINT_TEMPLATE_QR_CODE',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  RECEIPT_DATE = 'RECEIPT_DATE',
  RECEIPT_DATETIME = 'RECEIPT_DATETIME',
  RECEIPT_PAGE_NUMBER = 'RECEIPT_PAGE_NUMBER',
}

export enum CHOICE_FILTER_TYPES {
  CONSTANT_VALUE = 'constant_value',
  CONTROL_VALUE = 'control_value',
  CHOICE_ATTRIBUTE = 'choice_attribute',
}

export enum TICKET_INDICATORS {
  TRUCK = 'A',
  TRAILER = 'B',
  MAIN = 'C',
  TANDEM = 'D',
}

export enum QR_CODE_CHARS {
  FIELD_SEPARATOR = '$',
}

export enum PUSH_NOTIFICATION_TYPES {
  SYSTEM = 'SYSTEM',
  RETURN_TIME = 'RETURN_TIME',
}